<template>
<div>
    <div id="navigation" class="navbar navbar-default navbar-fixed-top" role="navigation">
        <div class="container">
            <div class="navbar-header">
                <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
                    <span class="sr-only">Toggle navigation</span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </button>
                <a class="navbar-brand" href="#"><img src="@/assets/picture/logo.png" width="100"></a>
            </div>
            <div class="collapse navbar-collapse">
                <ul class="nav navbar-nav navbar-right">
                    <li class="active"><a href="#h" class="smoothscroll">首页</a></li>
                    <li><a href="#test" class="smoothscroll">相关简介</a></li>
                    <li><a href="#chefs" class="smoothscroll">合作品牌</a></li>
                    <li><a href="#dishes" class="smoothscroll">相关产品</a></li>
                    <li><a href="#apps" class="smoothscroll">团购商城</a></li>
                    <li><a href="#contact" class="smoothscroll">联系我们</a></li>
                </ul>
            </div>
            <!--/.nav-collapse -->
        </div>
    </div>
    <!-- ********** HEADER SECTION ********** -->
    <div id="h">
        <div class="container">
            <div class="row">
                <div class="col-md-6 col-md-offset-3 welcome">
                    <h1>海鸿食惠鲜<br /><h3>一个专注食材供应链结合线上线下的团购平台</h3></h1>
                    <hr class="aligncenter">
                    <h4>提供数千种高品质、高性价比的产品和配套的配送服务，满足数千家餐饮企业一站式采购需求</h4><br />
                    <a href="#contact" class="smoothscroll">
                        <button type="submit" class="btn btn-large" href="#contact">联系我们</button>
                    </a>
                </div>
            </div>
            <!--/row -->
        </div>
        <!-- /.container -->
    </div>
    <!--/ H -->
    <!-- ********** WHITE SECTION ********** -->
    <div class="container" id="test">
        <div class="row mtb centered">
            <h3>相关简介</h3>
            <hr class="aligncenter mb">

            <div class="col-md-3">
                <i class="ion-ios-wineglass og"></i>
                <h5>合作共赢</h5>
                <p class="text-p">同一个目标携手共进，同一个梦想合作共赢。促进兄弟合作，共享发展新机遇!</p>
            </div>
            <!--/col-md-3 -->
            <div class="col-md-3">
                <i class="ion-ios-location og"></i>
                <h5>公司地址</h5>
                <p class="text-p">新疆乌鲁木齐市黄山街227号海鸿国际物流港</p>
            </div>
            <!--/col-md-3 -->
            <div class="col-md-3">
                <i class="ion-ios-calculator og"></i>
                <h5>团长返利</h5>
                <p class="text-p">可以选择自己发起拼团，做团长。也可以选择参团，做团员。高额佣金等您领取。</p>
            </div>
            <!--/col-md-3 -->
            <div class="col-md-3">
                <i class="ion-ios-cart og"></i>
                <h5>一键购物</h5>
                <p class="text-p">真正做到一键购物，操作方便，安全，快捷，满意。</p>
            </div>
            <!--/col-md-3 -->

        </div>
        <!--/row -->
    </div>
    <!--/container -->
    <!-- ********** PARALLAX SEPARATOR SECTION ********** -->
    <div class="sep s01" data-stellar-background-ratio="0.5"></div>

    <!-- ********** MEET THE CHEFS SECTION ********** -->
    <div class="container" id="chefs">
        <div class="row mtb">
            <h3 class="centered">合作品牌</h3>
            <hr class="aligncenter mb">
            <img src="@/assets/picture/chef01.png"  width="100%">
        </div>
        <!--/row -->
    </div>
    <!--/container -->
    <!-- ********** PARALLAX SEPARATOR SECTION ********** -->
    <div class="sep s02" data-stellar-background-ratio="0.5"></div>

    <!-- ********** MENU SLIDER SECTION ********** -->
    <div class="container" id="dishes">
        <div class="row mtb">
            <h3 class="centered">相关产品</h3>
            <hr class="aligncenter mb">
            <p class="text-p centered">部分产品. 您需要联系我们了解最新的海鸿产品信息.</p>
            <div class="col-md-10 col-md-offset-1">
                <div id="mi-slider" class="mi-slider">
                    <ul>
                        <li><a data-toggle="modal" data-target="#myModal"><img src="@/assets/picture/1.png" alt="img01">海鲜汇总</a></li>
                        <li><a data-toggle="modal" data-target="#myModal"><img src="@/assets/picture/2.png" alt="img02">海鲜汇总</a></li>
                        <li><a data-toggle="modal" data-target="#myModal"><img src="@/assets/picture/3.png" alt="img03">海鲜汇总</a></li>
                        <li><a data-toggle="modal" data-target="#myModal"><img src="@/assets/picture/4.png" alt="img04">海鲜汇总</a></li>
                    </ul>
                    <ul>
                        <li><a data-toggle="modal" data-target="#myModal"><img src="@/assets/picture/5.png" alt="img05">龙虾三文鱼</a></li>
                        <li><a data-toggle="modal" data-target="#myModal"><img src="@/assets/picture/6.png" alt="img06">龙虾三文鱼</a></li>
                        <li><a data-toggle="modal" data-target="#myModal"><img src="@/assets/picture/7.png" alt="img07">龙虾三文鱼</a></li>
                        <li><a data-toggle="modal" data-target="#myModal"><img src="@/assets/picture/8.png" alt="img08">龙虾三文鱼</a></li>
                    </ul>
                    <ul>
                        <li><a data-toggle="modal" data-target="#myModal"><img src="@/assets/picture/9.png" alt="img09">新鲜虾</a></li>
                        <li><a data-toggle="modal" data-target="#myModal"><img src="@/assets/picture/10.png" alt="img10">新鲜虾</a></li>
                        <li><a data-toggle="modal" data-target="#myModal"><img src="@/assets/picture/11.png" alt="img11">新鲜虾</a></li>
                    </ul>
                    <nav>
                        <a href="#">海鲜汇总</a>
                        <a href="#">龙虾三文鱼</a>
                        <a href="#">新鲜虾</a>
                    </nav>
                </div>
            </div>
            <!--/col-md-10 -->
        </div>
        <!--/row -->
    </div>
    <!--/container -->
    <!-- MODAL DEMO FOR A MENU ITEM -->
    <!-- Modal -->
    <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>
                    <h5 class="modal-title" id="myModalLabel">如想了解详情，请联系我们</h5>
                </div>
                <div class="modal-body">
                    <p class="text-p">海鸿食惠鲜期待您的加入.</p>
                    <p class="text-p">抓住红利，共赢未来！</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-warning" data-dismiss="modal">关闭</button>
                </div>
            </div>
        </div>
        <!--/modal-dialog -->
    </div>
    <!-- /modal -->
    <!-- ********** PARALLAX SEPARATOR SECTION ********** -->
    <div class="sep s03" data-stellar-background-ratio="0.5"></div>
    <!-- ********** PHONE USER SECTION ********** -->
    <div class="container" id="apps">
        <div class="row mt">
            <div class="col-md-4 col-md-offset-1">
                <h3>APP商城</h3>
                <hr class="mb">
                <p class="text-p">你可以使用我们的app</p>
                <p class="text-p">也可以使用我们的微信公众号</p>
                <p class="text-p">或者小程序</p>
                <p class="down">
                    <i class="ion-social-apple"></i>
                    <i class="ion-social-android"></i>
                </p>
            </div>
            <div class="col-md-6" style="float: left;">
                <p>
                    <img src="@/assets/picture/1525831716813.jpg" width="200" height="300" alt="">
                    <img src="@/assets/picture/1525831749759.jpg" width="222"  height="300" alt="">
                </p>
            </div>
        </div>
        <!--/row -->
    </div>
    <!--/container -->
    <!-- ********** FOOTER SECTION ********** -->
    <div id="f">
        <div class="container">
            <div class="row">
                <h3 class="centered">加入海鸿食惠鲜团购吧</h3>
                <hr class="aligncenter mb">
                <p class="text-p centered">我们会让你知道所有的优惠条件</p>
            </div>
            <!--/row -->
        </div>
        <!--/container -->
    </div>

    <div id="contact">
        <div class="container">
            <div class="col-md-8 col-md-offset-2">
                <h3 class="centered">联系我们</h3>
                <hr class="aligncenter mb">
                <form class="contact-form php-mail-form" role="form" method="POST" action="/Lies/Create">
                    <div class="form-group">
                        <label for="contact-name">您的姓名</label>
                        <input type="text" name="name" class="form-control" id="contact-name" placeholder="请输入您的姓名" data-rule="minlen:2" data-msg="请输入您的姓名">
                        <div class="validate"></div>
                    </div>
                    <div class="form-group">
                        <label for="contact-dh">您的电话</label>
                        <input type="text" name="dh" class="form-control" id="contact-dh" placeholder="请输入您的电话" data-rule="minlen:11" data-msg="请输入正确的电话">
                        <div class="validate"></div>
                    </div>
                    <div class="form-group">
                        <label for="contact-message">留言</label>
                        <textarea class="form-control" name="message" id="contact-message" placeholder="请输入您的留言" rows="5" data-rule="required" data-msg="请输入您的留言"></textarea>
                        <div class="validate"></div>
                    </div>
                    <div class="loading"></div>
                    <div class="error-message"></div>
                    <div class="sent-message">我们已收到您的留言，稍后会与您联系. Thank you!</div>
                    <div class="form-send">
                        <button type="submit" class="btn btn-large">提交信息</button>
                    </div>
                <input name="__RequestVerificationToken" type="hidden" value="CfDJ8GKvUonzVYZAumwMMzqVT_If4yoT3_WfD1iqKQlFLmyInyjRrEUi62UlIHJ21bfOIOz_PKDNMrEXWe5W8yX0uacAHfpDKhgXMIn-TIlauIVbv6l8p8BuOUH_-WYvWM87xQ7E1reevR8LCN4tezvulP0" /></form>
            </div>
        </div>
    </div>

    <div id="copyrights">
        <div class="container">
                <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=65010602000175"><img src="" style="float:left;"></a>
                <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=65010602000175" style="display: inline-block; height: 20px; line-height: 20px;"><img src="@/assets/picture/guohui.png" >新公网安备 65010602000175号</a>
                <span style="color: rgb(147, 147, 147);">&nbsp;| &nbsp;</span><span style=" color: rgb(102, 102, 102); font-family: PingFangSC, &quot;helvetica neue&quot;, &quot;hiragino sans gb&quot;, arial, &quot;microsoft yahei ui&quot;, &quot;microsoft yahei&quot;, simsun, sans-serif;"><a href="http://beian.miit.gov.cn">新ICP备14003058号-3</a> |&nbsp;</span>
                <span style="color: rgb(102, 102, 102); font-family: PingFangSC, &quot;helvetica neue&quot;, &quot;hiragino sans gb&quot;, arial, &quot;microsoft yahei ui&quot;, &quot;microsoft yahei&quot;, simsun, sans-serif;"><a href="http://beian.miit.gov.cn">增值电信业务经营许可证：新B2-20170056</a>&nbsp;&nbsp;</span>&nbsp;&nbsp;
        </div>
        <p>
            &copy; 2022Copyrights 版权由海鸿食惠鲜所有
        </p>
        <div class="credits">
        </div>
    </div>
</div>
</template>

<script>
    import "@/assets/css/bootstrap.min.css";
    import "@/assets/css/ionicons.min.css";
    import "@/assets/css/catslider.css";
    import "@/assets/css/style.css";
    import "@/assets/js/jquery.min.js";
    import "@/assets/js/bootstrap.min.js";
    import "@/assets/js/validate.js";
    import "@/assets/js/easing.min.js";
    import "@/assets/js/modernizr.custom.js";
    import "@/assets/js/stellar.min.js";
    import "@/assets/js/catslider.js";
    import "@/assets/js/main.js";
    export default {
        name: 'hhshx',
        data() {
            return {}
        },
    }
</script>

<style>

</style>